import React from "react";
import VAFamily from "../../PicesForPages/VA_family.jpg";
import FreeConsultation from "../Form/FreeConsultation";

function LicensesDisclosures() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent VALoansPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={VAFamily}
          alt="FHAFamilyImage"
          className="background-video VA_FamilyImage"
        />
        <div className="purchasetopBox VALoansPageTopBox">
          {/* The existing Purchase span */}
          <span>State Licenses & NMLS</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            {/* <span className="purchaseBottomLeftHeader">
              State Licenses & NMLS
            </span> */}
            <span className="purchaseBottomLeftContent">
              Vidhi Mortgage LLC is a licensed mortgage brokerage company.
              Please review our licensing and registration information below.
            </span>
            <span className="purchaseBottomLeftSubHeader">Company NMLS</span>
            <span className="purchaseBottomLeftContent">
              Verify our company information through the Nationwide Multistate
              Licensing System (NMLS) Consumer Access portal:
            </span>
            <a
              href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/COMPANY/2812139"
              target="_blank"
              rel="noreferrer"
              className="purchaseBottomLeftContent"
              style={{ color: "blue" }}
            >
              NMLS #2812139 — NMLS Consumer Access
            </a>
            <span className="purchaseBottomLeftSubHeader">
              States We're Licensed In
            </span>
            <span className="purchaseBottomLeftContent">
              Vidhi Mortgage LLC is currently licensed to originate mortgage
              loans in the following states:
            </span>
            <span className="purchaseBottomLeftContent">
              <span className="purchaseBottomLeftButtonLink purchaseBottomLeftContentStates">
                Florida
              </span>
              <span className="purchaseBottomLeftButtonLink purchaseBottomLeftContentStates">
                Ohio
              </span>
              <span className="purchaseBottomLeftButtonLink">Texas</span>
              {/* <span className="purchaseBottomLeftContentStates">Texas</span> */}
            </span>
            <span className="purchaseBottomLeftContent">
              Loan programs, rates, fees, and availability may vary by state and
              are subject to borrower qualification and applicable laws.
            </span>
            <span className="purchaseBottomLeftSubHeader">
              Equal Housing Opportunity
            </span>
            <span className="purchaseBottomLeftContent">
              Vidhi Mortgage LLC conducts business in accordance with the
              Federal Fair Housing Act and the Equal Credit Opportunity Act. We
              are committed to providing equal housing and lending opportunities
              to all applicants and do not discriminate on the basis of race,
              color, religion, national origin, sex, marital status, age,
              disability, familial status, sexual orientation, gender identity,
              receipt of public assistance, or any other protected basis under
              applicable law.
            </span>
            <span className="purchaseBottomLeftContent">
              Vidhi Mortgage LLC is an Equal Housing Opportunity mortgage
              brokerage.
            </span>
            <span className="purchaseBottomLeftSubHeader">
              Texas Disclosure:
            </span>
            <span className="purchaseBottomLeftContent">
              CONSUMERS WISHING TO FILE A COMPLAINT AGAINST A COMPANY OR A
              RESIDENTIAL MORTGAGE LOAN ORIGINATOR SHOULD COMPLETE AND SEND A
              COMPLAINT FORM TO THE TEXAS DEPARTMENT OF SAVINGS AND MORTGAGE
              LENDING, 2601 NORTH LAMAR, SUITE 201, AUSTIN, TEXAS 78705.
              COMPLAINT FORMS AND INSTRUCTIONS MAY BE OBTAINED FROM THE
              DEPARTMENT’S WEBSITE AT{" "}
              <span style={{ color: "blue", textDecoration: "underline" }}>
                WWW.SML.TEXAS.GOV
              </span>
              . A TOLL-FREE CONSUMER HOTLINE IS AVAILABLE AT 1-877-276-5550.
            </span>
            <span className="purchaseBottomLeftContent">
              THE DEPARTMENT MAINTAINS A RECOVERY FUND TO MAKE PAYMENTS OF
              CERTAIN ACTUAL OUT OF POCKET DAMAGES SUSTAINED BY BORROWERS CAUSED
              BY ACTS OF LICENSED RESIDENTIAL MORTGAGE LOAN ORIGINATORS. A
              WRITTEN APPLICATION FOR REIMBURSEMENT FROM THE RECOVERY FUND MUST
              BE FILED WITH AND INVESTIGATED BY THE DEPARTMENT PRIOR TO THE
              PAYMENT OF A CLAIM. FOR MORE INFORMATION ABOUT THE RECOVERY FUND,
              PLEASE CONSULT THE DEPARTMENT’S WEBSITE AT{" "}
              <span style={{ color: "blue", textDecoration: "underline" }}>
                WWW.SML.TEXAS.GOV
              </span>
              .
            </span>
            <span className="purchaseBottomLeftSubHeader">DISCLAIMER</span>
            <span className="purchaseBottomLeftContent">
              The information provided on this website is for informational
              purposes only and may not be used for any commercial purpose
              without the prior written consent of Vidhi Mortgage LLC.
            </span>
            <span className="purchaseBottomLeftContent">
              While we strive to keep the information on this website accurate
              and up to date, Vidhi Mortgage LLC makes no representations or
              warranties regarding the completeness, accuracy, reliability, or
              timeliness of any information provided. All information is subject
              to change without notice.
            </span>
            <span className="purchaseBottomLeftContent">
              The content of this website does not constitute an offer to lend,
              a commitment to lend, or a solicitation for any mortgage product
              or financial service. All loan programs, rates, fees, terms, and
              conditions are subject to change without notice and may vary based
              on borrower qualifications, property type, loan amount, state
              requirements, and other factors.
            </span>
            <span className="purchaseBottomLeftContent">
              Loan approval is subject to credit approval, underwriting
              guidelines, verification of information, and satisfaction of all
              applicable lending requirements.
            </span>
            <span className="purchaseBottomLeftContent">
              The information contained on this website is intended to be of a
              general nature and should not be construed as legal, tax,
              accounting, financial, or other professional advice. Before making
              any financial decision, you should consult with qualified legal,
              tax, or financial professionals regarding your individual
              circumstances.
            </span>
            <span className="purchaseBottomLeftContent">
              By using this website, you acknowledge that any reliance on
              information provided herein is at your own risk. Vidhi Mortgage
              LLC shall not be liable for any direct, indirect, incidental,
              consequential, special, or punitive damages arising from the use
              of, or inability to use, this website or any information contained
              herein.
            </span>
            <span className="purchaseBottomLeftContent">
              All content on this website, including text, graphics, logos,
              images, and other materials, is protected by applicable copyright,
              trademark, and intellectual property laws. No material from this
              website may be copied, reproduced, modified, distributed,
              displayed, published, or transmitted in any form without the prior
              written consent of Vidhi Mortgage LLC.
            </span>
            <span className="purchaseBottomLeftContent">
              Vidhi Mortgage LLC is a licensed mortgage brokerage company.
              Licensing information and NMLS registration details are available
              on this website and through the NMLS Consumer Access portal.
            </span>
            <div className="purchaseBottomLeftButton">
              <a
                href="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default LicensesDisclosures;
